import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import './ModalWhatsAppCliente.scss';

const ModalWhatsAppCliente = ({ 
    visible, 
    onHide, 
    dataUnidad, 
    dataUnidadVistaUnidad, 
    activeIndex,
    onSend 
}) => {
    const [telefono, setTelefono] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSend = async () => {
        if (!telefono || telefono.length < 10) {
            setError('Por favor ingrese un número de teléfono válido (mínimo 10 dígitos)');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const unidadInfo = activeIndex === 0 ? dataUnidad : dataUnidadVistaUnidad;
            await onSend(telefono, unidadInfo);
            setTelefono('');
            onHide();
        } catch (err) {
            setError('Error al enviar el mensaje. Intente nuevamente.');
        } finally {
            setLoading(false);
        }
    };

    const handlePhoneChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setTelefono(value);
        if (error) setError('');
    };

    const formatDataForPreview = () => {
        if (activeIndex === 0 && dataUnidad) {
            return {
                'ID Bitácora': dataUnidad.ID_BITACORA,
                'Unidad': dataUnidad.UNIDAD,
                'Tipo': dataUnidad.TIPO_UNIDAD,
                'Ruta': dataUnidad.RUTA,
                'Operador': dataUnidad.CHOFER,
                'Confirmada': dataUnidad.CONFIRMADA ? 'Sí' : 'No',
                'Capacidad': dataUnidad.CAPACIDAD ? `${dataUnidad.CAPACIDAD} pasajeros` : "POR CONFIRMAR",
                'Asientos disponibles': dataUnidad.ASIENTOS_DISPONIBLES,
                'Ubicación': dataUnidad.coordenadas.length > 0 ? `https://maps.google.com/?q=${dataUnidad.coordenadas[0]},${dataUnidad.coordenadas[1]}` : "No disponible"
            };
        } else if (activeIndex === 1 && dataUnidadVistaUnidad) {
            return {
                'Unidad': dataUnidadVistaUnidad.UNIDAD,
                'Estatus': dataUnidadVistaUnidad.ESTATUS,
                'Estado': dataUnidadVistaUnidad.ESTADO_UNIDAD,
                'Tipo': dataUnidadVistaUnidad.TIPO,
                'Ruta': dataUnidadVistaUnidad.RUTA || 'Sin ruta asignada',
                'Operador': dataUnidadVistaUnidad.OPERADOR || 'Sin operador'
            };
        }
        return {};
    };

    const dataPreview = formatDataForPreview();

    return (
        <Dialog
            header="Enviar WhatsApp al Cliente"
            visible={visible}
            onHide={onHide}
            style={{ width: '500px' }}
            className="modal-whatsapp-cliente"
            modal
            draggable={false}
            resizable={false}
        >
            <div className="modal-content">
                <div className="phone-section">
                    <label htmlFor="telefono" className="form-label">
                        <i className="pi pi-phone"></i>
                        Número de teléfono del cliente
                    </label>
                    <InputText
                        id="telefono"
                        value={telefono}
                        onChange={handlePhoneChange}
                        placeholder="Ej: 5512345678"
                        className="phone-input"
                        maxLength={15}
                    />
                    {error && (
                        <Message 
                            severity="error" 
                            text={error} 
                            className="error-message"
                        />
                    )}
                </div>

                <div className="preview-section">
                    <h4>
                        <i className="pi pi-info-circle"></i>
                        Información a enviar:
                    </h4>
                    <div className="info-preview">
                        {Object.entries(dataPreview).map(([key, value]) => {
                            console.log("key, value",key, value);
                            
                            return (
                                <div key={key} className="info-item">
                                    <span className="info-label">{key}:</span>
                                    {
                                        key == 'Ubicación'?
                                        value == 'No disponible' ?
                                        <span className="info-value">No disponible</span>
                                        :
                                        <a href={value} target="_blank" rel="noopener noreferrer">Ver en Google Maps</a>
                                    :
                                    <span className="info-value">{value}</span>
                                }
                            </div>
                        )})}
                    </div>
                </div>

                <div className="actions">
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        className="p-button-text"
                        onClick={onHide}
                        disabled={loading}
                    />
                    <Button
                        label={loading ? "Enviando..." : "Enviar WhatsApp"}
                        icon={loading ? "pi pi-spin pi-spinner" : "pi pi-whatsapp"}
                        onClick={handleSend}
                        disabled={loading || !telefono}
                        className="send-button"
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default ModalWhatsAppCliente;
